import { render, staticRenderFns } from "./ruAgreement.vue?vue&type=template&id=80233312&scoped=true&"
var script = {}
import style0 from "./ruAgreement.vue?vue&type=style&index=0&id=80233312&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80233312",
  null
  
)

export default component.exports